import { render, staticRenderFns } from "./SearchTaskList.vue?vue&type=template&id=65f86ca4&"
import script from "./SearchTaskList.vue?vue&type=script&lang=ts&"
export * from "./SearchTaskList.vue?vue&type=script&lang=ts&"
import style0 from "./SearchTaskList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports